<template>
  <div class="mb-5 dealer-wait-routes">
    <h4 class="title-2 bold mb-3">Esperas desde el {{ changeDayLabel }}</h4>
    <ContentMetrics>
      <template>
        <Metric :value="detail.totalRoutes" :title="'Rutas totales'" :border="true" />
        <Metric :value="detail.totalRoutesWithExcess" :title="'Rutas con demora'" :border="true" />
        <Metric :value="averageLabel" :title="'Exceso promedio (min)'" :border="true" />
        <Metric :value="notCountedRoutes" :title="'No cuentan'" :border="true" />
        <Metric :value="totalChargeLabel" :title="'Cobro del periodo'" />
      </template>
    </ContentMetrics>
    <p class="text-muted small mt-2">{{ averageNote }}</p>
    <el-table
      :data="detail.routes"
      row-key="id"
      header-row-class-name="thead-desing"
      class="table-responsive desing dealer-wait-table"
    >
      <el-table-column label="Fecha" prop="date" min-width="125px" />
      <el-table-column label="Ruta" prop="route" min-width="90px">
        <template v-slot="{ row }"><strong>{{ row.route }}</strong></template>
      </el-table-column>
      <el-table-column label="Hora programada" prop="scheduled_departure_time" min-width="135px" />
      <el-table-column label="Llegada del repartidor" prop="arrival_time" min-width="160px" />
      <el-table-column label="Inicio de ruta" prop="route_started_time" min-width="100px" />
      <el-table-column label="Espera (min)" prop="wait_minutes" min-width="95px" align="right">
        <template v-slot="{ row }">{{ describeWait(row) }}</template>
      </el-table-column>
      <el-table-column label="Exceso (min)" prop="excess_minutes" min-width="95px" align="right">
        <template v-slot="{ row }">{{ describeExcess(row) }}</template>
      </el-table-column>
      <el-table-column label="Estado" prop="status" min-width="160px">
        <template v-slot="{ row }"><DealerWaitStatusTag :status="describeRouteStatus(row)" /></template>
      </el-table-column>
      <el-table-column label="Cobro" prop="charge_amount" min-width="110px" align="right">
        <template v-slot:header="{ column }">{{ column.label }}<MetricInfoTooltip :content="chargeHelpText" /></template>
        <template v-slot="{ row }">{{ describeCharge(row) }}</template>
      </el-table-column>
    </el-table>
    <DealerWaitStatusLegend />
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import ContentMetrics from "@/components/Levels/ContentMetrics";
import Metric from "@/components/Levels/Metric";
import MetricInfoTooltip from "@/components/Levels/MetricInfoTooltip";
import DealerWaitStatusTag from "@/components/EsperaRepartidor/DealerWaitStatusTag";
import DealerWaitStatusLegend from "@/components/EsperaRepartidor/DealerWaitStatusLegend";
import { NO_WAIT_MARKS_LABEL, LEVEL_EXCESS_CAP_MINUTES } from "@/utils/dealerWaitThresholds";
import { buildWaitChargeHelpText, formatFormulaChangeDay, formatMoney } from "@/utils/dailyMenuLevelHelpTexts";
import { describeWait, describeExcess, countNotCountedRoutes } from "@/utils/dealerWaitRows";
import { describeRouteStatus } from "@/utils/dealerWaitRouteStatus";

export default {
  name: "DealerWaitRoutesSection",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ContentMetrics,
    Metric,
    MetricInfoTooltip,
    DealerWaitStatusTag,
    DealerWaitStatusLegend
  },
  props: {
    detail: { type: Object, required: true },
    chargeTiers: { type: Array, default: () => [] }
  },
  computed: {
    changeDayLabel() {
      return formatFormulaChangeDay(this.detail.formulaChangeDate);
    },
    averageLabel() {
      return this.detail.averageWaitExcessMinutes === null ? NO_WAIT_MARKS_LABEL : this.detail.averageWaitExcessMinutes;
    },
    notCountedRoutes() {
      return countNotCountedRoutes(this.detail.routes);
    },
    totalChargeLabel() {
      return formatMoney(this.detail.currency, this.detail.totalCharge);
    },
    averageNote() {
      return `En el promedio, cada ruta cuenta como máximo ${LEVEL_EXCESS_CAP_MINUTES} minutos; abajo ves el exceso real de cada ruta. Las esperas de más de ${this.detail.maxPlausibleExcessHours} horas se descartan por error de marca.`;
    },
    chargeHelpText() {
      return buildWaitChargeHelpText(this.chargeTiers, this.detail.formulaChangeDate);
    }
  },
  methods: {
    describeWait,
    describeExcess,
    describeRouteStatus,
    describeCharge(row) {
      return row.charge_amount === null ? NO_WAIT_MARKS_LABEL : formatMoney(this.detail.currency, row.charge_amount);
    }
  }
};
</script>

<style scoped>
.dealer-wait-routes ::v-deep .el-table th,
.dealer-wait-routes ::v-deep .el-table td {
  padding-left: 12px;
  padding-right: 12px;
}
</style>
